import { render, staticRenderFns } from "./EnableTwoFactorModal.vue?vue&type=template&id=cc4b3fe2&"
import script from "./EnableTwoFactorModal.vue?vue&type=script&lang=js&"
export * from "./EnableTwoFactorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports